import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { WordDrillContext } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._context";
import { DrillPageSentenceStrip } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._components.sentence-strip";
import type { DrillPageSentenceDrill } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._lib.sentence-drill";
import { ActivityIndicator, View } from "@-/com.npmjs.react-native";
import type { DrillPageHeaderTextsVariant } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._components.header-texts";

/**
 * The front of a sentence-production card: the sentence's ENGLISH translation, then the Chinese
 * sentence being built up beneath it.
 *
 * The Chinese sentence is never shown as text — it IS the answer, and the strip reveals it one
 * token at a time as the user produces (or is given) each word.
 */
export function DrillPageSentencePrompt({
  sentenceDrill,
  variant,
}: {
  sentenceDrill: DrillPageSentenceDrill;
  variant: DrillPageHeaderTextsVariant;
}) {
  const [translation] = useContextSelectors(WordDrillContext, (c) => c.sentence.translation);

  const translationClassName =
    variant === "landscape-compact"
      ? "text-center font-sans text-[16px] leading-tight"
      : "text-center font-sans text-[20px] leading-tight";

  return (
    <View className="w-full items-center gap-6 px-2">
      <Text className={translationClassName} colorVariant="muted">
        {`“${translation}”`}
      </Text>
      {sentenceDrill.isPending ? (
        // Keep a spinner until segmentation produces the complete sentence strip.
        <ActivityIndicator accessibilityLabel="Loading sentence" size="small" />
      ) : (
        <DrillPageSentenceStrip state={sentenceDrill.state} />
      )}
    </View>
  );
}
